module.exports = __webpack_public_path__ + "img/sqxf.980586c2.png";